import camelcase from 'camelcase'
import _ from 'lodash'

export default class EntityProductModel {
  id = null
  name = null
  tag = null
  commission = 0
  grossAmount = 0
  feeAmount = 0
  activeFrom = null
  activeUntil = null
  status = 'active'
  changeDate = null
  changeUser = null
  parentId = null
  productId = null

  children = []

  constructor(data = {}) {
    _.forEach(data, (value, field) => {
      this[camelcase(field)] = value
    })

    this.children =
      data.children &&
      _.map(data.children, (child) => new EntityProductModel(child))
  }
}
